import * as React from 'react';
import { css } from '@emotion/react';

import ResourceCard from './ResourceCard';
import ViewMoreResourcesCard from './ViewMoreResourcesCard';
import tools from '../data/tools';

const styles = {
  wrapper: css`
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  `,
};

const ToolCards = ({
  className: appliedClassName = undefined,
  css: appliedCss = undefined,
  id: appliedId = undefined,
  showJustHomepage = false,
}) => {
  const displayedTools = tools
    .filter(node => !showJustHomepage || node?.homepage)
    .map(node => <ResourceCard data={node} />);

  return (
    <div
      className={appliedClassName}
      css={[styles.wrapper, appliedCss]}
      id={appliedId}
    >
      {displayedTools}
      {displayedTools.length < tools.length && <ViewMoreResourcesCard href="tools/" />}
    </div>
  );
}

export default ToolCards;
